import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Camera, ImageOff } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api, errMsg, istDateTime } from "@/lib/api";

const BASE = process.env.REACT_APP_BACKEND_URL;

export const ChartSnapshot = ({ date }) => {
  const [snap, setSnap] = useState(undefined);
  const [busy, setBusy] = useState(false);
  const load = useCallback(() => api.get("/reports/snapshot", { params: { date } }).then((r) => setSnap(r.data.snapshot)).catch(() => setSnap(null)), [date]);
  useEffect(() => { setSnap(undefined); load(); }, [load]);
  const save = async () => {
    setBusy(true);
    try { setSnap((await api.post("/reports/snapshot", null, { params: { date } })).data); toast.success("Chart snapshot saved"); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="mt-3 rounded-md border border-slate-800 bg-[#0B0F1A]" data-testid="report-chart-snapshot">
      <div className="flex flex-wrap items-center justify-between gap-2 border-b border-slate-800 px-3 py-2">
        <span className="eyebrow">Chart snapshot · {date}</span>
        <div className="flex items-center gap-3">
          {snap && <span className="text-[11px] text-slate-500" data-testid="snapshot-meta">{snap.source === "auto" ? "Auto-saved" : "Saved"} {istDateTime(snap.created_at)}</span>}
          <Button data-testid="button-save-snapshot" size="sm" variant="outline" disabled={busy} onClick={save} className="h-7 gap-1 border-slate-700 text-xs">
            <Camera size={12} /> {busy ? "Rendering…" : snap ? "Re-save now" : "Save snapshot now"}
          </Button>
        </div>
      </div>
      {snap === undefined && <div className="h-40 animate-pulse bg-slate-900/40" />}
      {snap === null && (
        <div className="flex items-center gap-2 px-3 py-6 text-xs text-slate-500" data-testid="snapshot-empty">
          <ImageOff size={14} /> No snapshot yet. One is saved automatically at 15:40 IST on trading days, or save one now.
        </div>
      )}
      {snap && (
        <a href={`${BASE}${snap.url}`} target="_blank" rel="noreferrer">
          <img data-testid="snapshot-image" src={`${BASE}${snap.url}`} alt={`NIFTY chart ${date}`} className="w-full rounded-b-md" loading="lazy" />
        </a>
      )}
    </div>
  );
};
